import { render } from "./goodsDetail.vue?vue&type=template&id=0f022270&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"

import "./goodsDetail.vue?vue&type=style&index=0&id=0f022270&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f022270"]])

export default __exports__